<div *transloco="let t">
	<table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort>
		<!--        <ng-container matColumnDef="family">-->
		<!--            <th mat-header-cell *matHeaderCellDef>-->
		<!--                {{t('uviCalc.family')}}-->
		<!--            </th>-->
		<!--            <td mat-cell *matCellDef="let row" [attr.data-label]="t('uviCalc.family')">-->
		<!--            </td>-->
		<!--        </ng-container>-->

		<ng-container matColumnDef="deviceNumber">
			<th *matHeaderCellDef mat-header-cell>
				{{ t('devices.deviceNumber') }}
			</th>
			<td *matCellDef="let row" [attr.data-label]="t('devices.deviceNumber')" mat-cell>
				{{ row.deviceNumber }}
			</td>
		</ng-container>

		<ng-container matColumnDef="communicationNumber">
			<th *matHeaderCellDef mat-header-cell>
				{{ t('uviCalc.communicationNumber') }}
			</th>
			<td *matCellDef="let row" [attr.data-label]="t('uviCalc.communicationNumber')" mat-cell>
				{{ row.communicationNumber }}
			</td>
		</ng-container>

		<ng-container matColumnDef="physicalUnit">
			<th *matHeaderCellDef mat-header-cell>
				{{ t('uviCalc.physicalUnit') }}
			</th>
			<td *matCellDef="let row" [attr.data-label]="t('uviCalc.physicalUnit')" mat-cell>
				{{ t('enum.' + row.physicalUnit) }}
			</td>
		</ng-container>

		<ng-container matColumnDef="beginReadingDate">
			<th *matHeaderCellDef mat-header-cell>{{ t('readingValues.readingDate') }} 1</th>
			<td *matCellDef="let row" [attr.data-label]="t('readingValues.readingDate')" mat-cell>
				{{ row.beginReadingDate | date: 'dd.MM.YYYY' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="readingValue1">
			<th *matHeaderCellDef mat-header-cell>{{ t('readingValues.readingValue') }} 1</th>
			<td *matCellDef="let row" [attr.data-label]="t('readingValues.readingValue')" mat-cell>
				{{ row.readingValue1 }}
			</td>
		</ng-container>

		<ng-container matColumnDef="endReadingDate">
			<th *matHeaderCellDef mat-header-cell>{{ t('readingValues.readingDate') }} 2</th>
			<td *matCellDef="let row" [attr.data-label]="t('readingValues.readingDate')" mat-cell>
				{{ row.endReadingDate | date: 'dd.MM.YYYY' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="readingValue2">
			<th *matHeaderCellDef mat-header-cell>{{ t('readingValues.readingValue') }} 2</th>
			<td *matCellDef="let row" [attr.data-label]="t('readingValues.readingValue')" mat-cell>
				{{ row.readingValue2 }}
			</td>
		</ng-container>

		<ng-container matColumnDef="readingValueTimeShare">
			<th *matHeaderCellDef mat-header-cell>
				{{ t('uviCalc.readingValueTimeShare') }}
			</th>
			<td *matCellDef="let row" [attr.data-label]="t('uviCalc.readingValueTimeShare')" mat-cell>
				{{ row.readingValueTimeShare }}
			</td>
		</ng-container>

		<ng-container matColumnDef="periodTimeShare">
			<th *matHeaderCellDef mat-header-cell>
				{{ t('uviCalc.periodTimeShare') }}
			</th>
			<td *matCellDef="let row" [attr.data-label]="t('uviCalc.periodTimeShare')" mat-cell>
				{{ row.periodTimeShare }}
			</td>
		</ng-container>

		<ng-container matColumnDef="monthlyConsumption">
			<th *matHeaderCellDef mat-header-cell>
				{{ t('uviCalc.monthlyConsumption') }}
			</th>
			<td *matCellDef="let row" [attr.data-label]="t('uviCalc.monthlyConsumption')" mat-cell>
				{{ row.consumptionWithTimeFactor }}
			</td>
		</ng-container>

		<ng-container matColumnDef="unit2KwhConversionFactorForUser">
			<th *matHeaderCellDef mat-header-cell>
				{{ t('uviCalc.unit2KwhConversionFactorForUser') }}
			</th>
			<td *matCellDef="let row" [attr.data-label]="t('uviCalc.unit2KwhConversionFactorForUser')" mat-cell>
				{{ row.unit2KwhConversionFactorForUser }}
			</td>
		</ng-container>

		<ng-container matColumnDef="consumption">
			<th *matHeaderCellDef mat-header-cell>
				{{ t('uviCalc.consumptionKwh') }}
			</th>
			<td *matCellDef="let row" [attr.data-label]="t('uviCalc.consumptionKwh')" mat-cell>
				{{ row.consumptionAsKwh }}
			</td>
		</ng-container>

		<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
		<tr *matRowDef="let row; columns: displayedColumns" @fadeInUp class="hover:bg-hover trans-ease-out cursor-pointer" mat-row></tr>

		<!-- Row shown when there is no matching data. -->
		<tr *matNoDataRow class="mat-row">
			<td class="mat-cell" colspan="4">
				<div class="ml-4">{{ t('dashboard.noDataFound') }}</div>
			</td>
		</tr>
	</table>
</div>
